import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';
import { fetchPositions } from '../reducers/positionSlice';
import { PortfolioPage } from '../routes/portfolio-page';

interface PortfolioPageContainerProps {}

export const PortfolioPageContainer: React.FC<PortfolioPageContainerProps> = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { positions } = useSelector((state: RootState) => state.alpaca);

    React.useEffect(() => {
        dispatch(fetchPositions());
    }, [dispatch]);

    return (
        <PortfolioPage positions={positions} />
    );
};
